module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight--dark-05cbdd2ecb9c7946320503a78aef22f9.png";